import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { company } from "../mock/mock";

const Footer = () => {
  return (
    <footer className="bg-[#131f38] text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="inline-flex items-center mb-4 group">
              <div className="bg-white rounded-xl p-2 shadow-sm transition-transform duration-300 group-hover:scale-105">
                <img
                  src={company.logo}
                  alt={company.name}
                  className="h-14 w-auto object-contain"
                />
              </div>
            </Link>
            <p className="text-sm leading-relaxed text-gray-400">
              {company.tagline} Particuliers et professionnels, un service premium partout en France.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              {[
                { label: "Accueil", path: "/" },
                { label: "Particuliers", path: "/particuliers" },
                { label: "Professionnels", path: "/professionnels" },
                { label: "Calculateur de volume", path: "/calculateur" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-400 hover:text-[#C9A227] transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Nos services</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/particuliers" className="text-gray-400 hover:text-[#C9A227] transition-colors">Déménagement particulier</Link></li>
              <li><Link to="/professionnels" className="text-gray-400 hover:text-[#C9A227] transition-colors">Déménagement d'entreprise</Link></li>
              <li><Link to="/garde-meubles" className="text-gray-400 hover:text-[#C9A227] transition-colors">Garde-meubles & stockage</Link></li>
              <li><Link to="/location-materiel" className="text-gray-400 hover:text-[#C9A227] transition-colors">Location de matériel</Link></li>
              <li><Link to="/transport-objet" className="text-gray-400 hover:text-[#C9A227] transition-colors">Transport d'objet</Link></li>
              <li><Link to="/calculateur" className="text-gray-400 hover:text-[#C9A227] transition-colors">Calculateur de volume</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-[#C9A227] mt-0.5 shrink-0" />
                <a href={`tel:${company.phone.replace(/\s/g, "")}`} className="hover:text-[#C9A227] transition-colors">
                  {company.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-[#C9A227] mt-0.5 shrink-0" />
                <a href={`mailto:${company.email}`} className="hover:text-[#C9A227] transition-colors break-all">
                  {company.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#C9A227] mt-0.5 shrink-0" />
                <span>{company.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">
            © {new Date().getFullYear()} DMP Déménagement. Tous droits réservés.
          </p>
          <p className="text-xs text-gray-500">
            Devis gratuit et sans engagement • Assurance tous risques
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
